import request from './index';

export function addProduct(data) {
  return request.post('officialPageProduct/add', data);
}

export function updateProduct(data) {
  return request.post('officialPageProduct/update', data);
}

export function deleteProduct(id) {
  return request.post('officialPageProduct/delete', { id });
}

export function getProductDetail(id) {
  return request.get('officialPageProduct/detail', { params: { id } });
}

export function getProductPage(params) {
  return request.get('officialPageProduct/page', { params });
}

export function getProductList(params) {
  return request.get('officialPageProduct/list', { params });
}
